export const EVENTS = {
  CART: {
    LOAD: 'cart.load',
    LOADING: 'cart.loading',
    LOADED: 'cart.loaded',
    LOAD_ERROR: 'cart.load_error',

    ITEM_ADDED: 'cart.item_added',
    ITEM_REMOVED: 'cart.item_removed',
    QUANTITY_CHANGED: 'cart.quantity_changed',

    ITEMS: {
      ADD: 'cart.items.add',
      ADDING: 'cart.items.adding',
      ADDED: 'cart.items.added',
      ADD_ERROR: 'cart.items.add_error',

      UPDATE: 'cart.items.update',
      UPDATING: 'cart.items.updating',
      UPDATED: 'cart.items.updated',
      UPDATE_ERROR: 'cart.items.update_error',

      REMOVE: 'cart.items.remove',
      REMOVING: 'cart.items.removing',
      REMOVED: 'cart.items.removed',
      REMOVE_ERROR: 'cart.items.remove_error',

      // NEW - Options & Drinks
      OPTIONS: {
        UPDATE: 'cart.items.options.update',
        UPDATING: 'cart.items.options.updating',
        UPDATED: 'cart.items.options.updated',
        UPDATE_ERROR: 'cart.items.options.update_error'
      },

      DRINKS: {
        UPDATE: 'cart.items.drinks.update',
        UPDATING: 'cart.items.drinks.updating',
        UPDATED: 'cart.items.drinks.updated',
        UPDATE_ERROR: 'cart.items.drinks.update_error'
      },

      ACCOMPANIMENTS: {
        UPDATE: 'cart.items.accompaniments.update',
        UPDATING: 'cart.items.accompaniments.updating',
        UPDATED: 'cart.items.accompaniments.updated',
        UPDATE_ERROR: 'cart.items.accompaniments.update_error'
      }
    },

    CLEAR: 'cart.clear',
    CLEARING: 'cart.clearing',
    CLEARED: 'cart.cleared',
    CLEAR_ERROR: 'cart.clear_error',

    // NEW - Dialog control
    SHOW: 'cart.show',
    HIDE: 'cart.hide',

    TEMP_CART_LOADING: 'cart.TEMP_CART_LOADING',
    TEMP_CART_LOADED: 'cart.TEMP_CART_LOADED',
    TEMP_CART_UPDATED: 'cart.TEMP_CART_UPDATED',

    // NEW - Payment events
    FEES_CALCULATE: 'cart.fees.calculate',
    FEES_CALCULATING: 'cart.fees.calculating',
    FEES_CALCULATED: 'cart.fees.calculated',
    FEES_CALCULATE_ERROR: 'cart.fees.calculate_error',

    // NEW - Order fees calculation (with distance)
    ORDER_FEES_CALCULATE: 'cart.order_fees.calculate',
    ORDER_FEES_CALCULATING: 'cart.order_fees.calculating',
    ORDER_FEES_CALCULATED: 'cart.order_fees.calculated',
    ORDER_FEES_CALCULATE_ERROR: 'cart.order_fees.calculate_error',
    
    // NEW - Global Drinks (Cart level)
    DRINKS: {
      UPDATE: 'cart.drinks.update',
      UPDATING: 'cart.drinks.updating',
      UPDATED: 'cart.drinks.updated',
      UPDATE_ERROR: 'cart.drinks.update_error'
    },

    // NEW - Coupon events
    COUPON: {
      APPLY: 'cart.coupon.apply',
      APPLYING: 'cart.coupon.applying',
      APPLIED: 'cart.coupon.applied',
      APPLY_ERROR: 'cart.coupon.apply_error',
      REMOVE: 'cart.coupon.remove',
      REMOVING: 'cart.coupon.removing',
      REMOVED: 'cart.coupon.removed',
      REMOVE_ERROR: 'cart.coupon.remove_error'
    }
  }
};

export const ENDPOINTS = {
  CART: {
    // Tous les endpoints prennent le userId dans l'URL ou en paramètre + ?group=ultraxeno (ajouté globalement)
    GET: 'https://api.monrapidoo.com/cart/user/{userId}?group=ultraxeno',
    FEES_CALCULATE: 'https://api.monrapidoo.com/cart/fees/update?group=ultraxeno',
    APPLY_COUPON: 'https://api.monrapidoo.com/cart/coupon/apply/{userId}?group=ultraxeno', 
    REMOVE_COUPON: 'https://api.monrapidoo.com/cart/coupon/remove/{userId}?group=ultraxeno', 
    VALIDATE_COUPON: 'https://api.monrapidoo.com/coupons/validate?group=ultraxeno',
    ITEMS: {
      ADD: 'https://api.monrapidoo.com/cart/item/add?group=ultraxeno',
      QUANTITY: 'https://api.monrapidoo.com/cart/item/quantity/{userId}/{itemId}?group=ultraxeno', // Set explicit quantity
      INCREASE: 'https://api.monrapidoo.com/cart/item/increase/{userId}/{itemId}?group=ultraxeno',
      DECREASE: 'https://api.monrapidoo.com/cart/item/decrease/{userId}/{itemId}?group=ultraxeno',
      REMOVE: 'https://api.monrapidoo.com/cart/item/remove/{userId}/{itemId}?group=ultraxeno',
      
      // Incremental endpoints for options/accompaniments/drinks
      OPTIONS: {
        ADD: 'https://api.monrapidoo.com/cart/option/add/{userId}?group=ultraxeno',
        INCREASE: 'https://api.monrapidoo.com/cart/option/increase/{userId}/{itemId}/{optionId}?group=ultraxeno',
        DECREASE: 'https://api.monrapidoo.com/cart/option/decrease/{userId}/{itemId}/{optionId}?group=ultraxeno',
        REMOVE: 'https://api.monrapidoo.com/cart/option/remove/{userId}/{itemId}/{optionId}?group=ultraxeno'
      },
      ACCOMPANIMENTS: {
        ADD: 'https://api.monrapidoo.com/cart/accompaniment/add/{userId}?group=ultraxeno',
        INCREASE: 'https://api.monrapidoo.com/cart/accompaniment/increase/{userId}/{itemId}/{accId}?group=ultraxeno',
        DECREASE: 'https://api.monrapidoo.com/cart/accompaniment/decrease/{userId}/{itemId}/{accId}?group=ultraxeno',
        REMOVE: 'https://api.monrapidoo.com/cart/accompaniment/remove/{userId}/{itemId}/{accId}?group=ultraxeno'
      },
      DRINKS: {
        INCREASE: 'https://api.monrapidoo.com/cart/drink/increase/{userId}/{drinkId}?group=ultraxeno',
        DECREASE: 'https://api.monrapidoo.com/cart/drink/decrease/{userId}/{drinkId}?group=ultraxeno',
        REMOVE: 'https://api.monrapidoo.com/cart/drink/remove/{userId}/{drinkId}?group=ultraxeno'
      }
    },
    // Global drinks
    DRINKS: {
      ADD: 'https://api.monrapidoo.com/cart/drink/add?group=ultraxeno',
      INCREASE: 'https://api.monrapidoo.com/cart/drink/increase/{userId}/{drinkId}?group=ultraxeno',
      DECREASE: 'https://api.monrapidoo.com/cart/drink/decrease/{userId}/{drinkId}?group=ultraxeno',
      REMOVE: 'https://api.monrapidoo.com/cart/drink/remove/{userId}/{drinkId}?group=ultraxeno'
    },
    CLEAR: 'https://api.monrapidoo.com/cart/empty/user/{userId}?group=ultraxeno'
  },
  TEMP_CART: {
    // Note: Temp cart is now fully local, these endpoints are no longer called externally
    GET: '/api/temp-cart',
    UPSERT: '/api/temp-cart',
    DELETE: '/api/temp-cart'
  },
  RESTAURANTS: {
    DRINKS: '/api/restaurants/{restaurantId}/drinks' 
  }
};
